module.exports = __webpack_public_path__ + "img/public/siteImages/errorIconRed.svg?df33b660";